import { Pipe, PipeTransform } from '@angular/core';
import { EMailAudit } from '../classes';

@Pipe({
  name: 'mailTransmitter'
})
export class MailTransmitterPipe implements PipeTransform {

  transform(mail: EMailAudit): string {
    if(!mail || !Array.isArray(mail.transmitter)) return null;
    return mail.transmitter.map(x => x.address).filter(x => x? true: false).join(', ');
  }

}
